/* SAP'S STORE — Theme JS
   Mobile drawer, product gallery, quantity controls.
*/
(function () {
  'use strict';

  // Mobile drawer
  const drawer = document.querySelector('[data-mobile-drawer]');
  const openBtn = document.querySelector('[data-mobile-open]');
  const closeBtns = document.querySelectorAll('[data-mobile-close]');

  if (openBtn && drawer) {
    openBtn.addEventListener('click', () => drawer.classList.add('is-open'));
  }
  closeBtns.forEach(b => b.addEventListener('click', () => drawer && drawer.classList.remove('is-open')));
  if (drawer) {
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) drawer.classList.remove('is-open');
    });
  }

  // Product gallery thumbnails
  const mainImageWrap = document.querySelector('[data-main-image]');
  const thumbs = document.querySelectorAll('[data-thumb]');
  if (mainImageWrap && thumbs.length > 0) {
    const mainImg = mainImageWrap.querySelector('img');
    thumbs.forEach(t => {
      t.addEventListener('click', () => {
        thumbs.forEach(x => x.classList.remove('is-active'));
        t.classList.add('is-active');
        if (mainImg) mainImg.src = t.dataset.image;
      });
    });
  }

  // Quantity buttons on PDP
  const qtyMinus = document.querySelector('[data-qty-minus]');
  const qtyPlus = document.querySelector('[data-qty-plus]');
  if (qtyMinus && qtyPlus) {
    const input = qtyMinus.parentElement.querySelector('input');
    qtyMinus.addEventListener('click', () => {
      const v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });
    qtyPlus.addEventListener('click', () => {
      const v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
    });
  }

  // Variant selector → update hidden id, price
  const variantIdInput = document.querySelector('[data-variant-id]');
  const priceEl = document.querySelector('[data-price]');
  const selectors = document.querySelectorAll('[data-option-selector]');

  if (variantIdInput && selectors.length > 0 && window.productVariants) {
    const updateVariant = () => {
      const selected = Array.from(selectors).map(s => s.value);
      const variant = window.productVariants.find(v =>
        v.options.every((opt, i) => opt === selected[i])
      );
      if (variant) {
        variantIdInput.value = variant.id;
        if (priceEl) {
          priceEl.innerHTML = variant.compare_at_price > variant.price
            ? `<del>${formatMoney(variant.compare_at_price)}</del> <span class="sale">${formatMoney(variant.price)}</span>`
            : formatMoney(variant.price);
        }
      }
    };
    selectors.forEach(s => s.addEventListener('change', updateVariant));
  }

  function formatMoney(cents) {
    const value = (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0 });
    return `$${value} COP`;
  }

  // Expose for other scripts
  window.SapsTheme = { formatMoney };
})();
